// extracted by mini-css-extract-plugin
module.exports = {"container":"_1r2Wtbq","iconContainer":"_3tetmq9","counter":"mKkjR8v"};